import React, { useEffect, useContext, useState, useCallback } from 'react'
import {
  Grid,
  Container,
  TextField,
  useMediaQuery,
  Divider,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  Select,
  MenuItem,
  FormHelperText,
  CircularProgress,
} from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import { TextDivider } from '../Core/TextDivier'
import { EMAIL_REGEX, STATES } from '../../Constants'
import { Controller, useForm } from 'react-hook-form'
import { BrowserView, MobileView } from 'react-device-detect'
import NewFillButton from '../Core/NewFillButton'
import { BottomSheetPolicySummary } from '../Insurance/BottomSheetPolicySummary'
import { GreenButton } from '../Core/Buttons/GreenButton'
import { awaitWithLoading } from '../../services/utils'
import { SessionContextStore } from '../../context/SessionContext'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { useHistory } from 'react-router-dom'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import { ERROR_CODES } from '../../models/errors/ErrorCodes'
import BrokerConfigService from '../../services/BrokerConfigService'
import { UserApi } from '../../api/user.api'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import { SessionService } from '../../services/SessionService'
import { ContinueButton } from '../Core/Buttons/ContinueButton'
import { reportGTM } from '../Core/Utilities/GTagManger'
import { useLocation } from 'react-router-dom'
import { OutlinedButton } from '../Core/Buttons/OutLinedButton'
import { useAdministrativeDivisions } from '../Core/Hooks/useAdministrativeDivision'

export const Welcome = () => {
  const [open, setOpen] = useState(false)
  const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'))
  const history = useHistory()
  const [showPasswordlessVerifyMsg, setShowPSVerifyMsg] = React.useState(false)
  const { register, errors, setValue, setError, getValues, clearError, triggerValidation, control } = useForm()
  const sessionContext = React.useContext(SessionContextStore)
  const { isLoadingStates, isErrorStates, administrativeDivisions: statesLive } = useAdministrativeDivisions(true)
  const location = useLocation()

  const termsHref = history.createHref({ pathname: 'https://www.voominsurance.com/terms-of-service' })
  const privacyHref = history.createHref({ pathname: 'https://www.voominsurance.com/privacy-policy' })

  const existsPasswordlessLoginAttempt = res => {
    return res && !res.ok && res.status == 400 && res.data.code && res.data.code == ERROR_CODES.PASSWORDLESS_USER_LOGIN_ATTEMPT_ERROR
  }

  const handleDisagree = () => {
    setValue('administrativeDivision', 'default')
    setOpen(false)
  }
  const handleClickOpen = () => {
    setOpen(true)
  }

  const userAlreadyExistsResponse = res => {
    return res && !res.ok && res.status == 400 && res.data.code && res.data.code == ERROR_CODES.USER_ALREADY_EXISTS_ERROR
  }

  const onContinue = async () => {
    let valid = await triggerValidation()

    if (!valid) return

    if (statesLive.findIndex(liveState => getValues()['administrativeDivision'] === liveState.code) == -1) {
      handleClickOpen()
      reportGTM('', '', { event: 'unsupported-state-error', state: STATES[getValues()['administrativeDivision']] })
      return
    }
    sessionContext.user.state = getValues()['administrativeDivision']
    var url = '/insurance/profile' + window.location.search
    history.push(url)
  }

  useEffect(() => {
    if (SessionService.isLoggedIn()) history.push('/insurance')
  }, [])

  const openTermsAndCondition = e => {
    e.preventDefault()
    window.open(termsHref.toString(), '_blank')
  }

  const openPrivacyPolicy = e => {
    e.preventDefault()
    window.open(privacyHref.toString(), '_blank')
  }

  const routeToLoginViaRetrieveAQuote = () => {
    history.push('/login')
    reportGTM(location, 'Retrieve_a_quote')
  }

  const routeToLoginViaLogin = () => {
    history.push('/login')
    reportGTM(location, 'Log_in')
  }

  return showPasswordlessVerifyMsg ? (
    <FlexView column hAlignContent={'center'}>
      <MailOutlineIcon className="x-large-icon blue margin-bottom-18" />
      <div className="text-body textcenter margin-bottom-18">A link to verify your email has been sent to {getValues()['email']}</div>
      <div className="texy-body textcenter bold">Please check your email to continue</div>
    </FlexView>
  ) : (
    <Container>
      <Dialog open={open} onClose={handleDisagree} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">We're on our way!</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Coverage isn't supported in your state yet.
            <br />
            Sign up below to receive an email when we're available in your area.
          </DialogContentText>
          <DialogActions>
            <TextField
              variant="outlined"
              type="email"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <MailOutlineIcon className="lightgrayblue" />
                  </InputAdornment>
                ),
              }}
              className="margin-top-small margin-bottom-basic notify-me-input"
              placeholder="your@email.com"
              name="email"
              inputRef={register({ required: true, pattern: { value: EMAIL_REGEX, message: 'Invalid email address' } })}
              helperText={!!errors.email && (errors.email.message || 'Email required')}
              error={!!errors.email}
            />

            {!isLoadingStates ? (
              <Controller
                control={control}
                name="newAdministrativeDivision"
                rules={{ required: true, validate: field => field && field !== 'default' }}
                as={
                  <TextField
                    select
                    defaultValue={'default'}
                    variant="outlined"
                    className="margin-top-small margin-bottom-basic notify-me-dropdown"
                    helperText={!!errors.newAdministrativeDivision && (errors.newAdministrativeDivision.message || 'Please select a state')}
                    error={!!errors.newAdministrativeDivision}
                  >
                    <MenuItem disabled value={'default'}>
                      <div className="placeholder-text">State</div>
                    </MenuItem>
                    {Object.keys(STATES).map(administrativeDivision => {
                      const isLive = statesLive.some(operatingState => operatingState.code === administrativeDivision)
                      return (
                        !isLive && (
                          <MenuItem key={administrativeDivision} value={administrativeDivision}>
                            {administrativeDivision}
                          </MenuItem>
                        )
                      )
                    })}
                  </TextField>
                }
              />
            ) : (
              <CircularProgress />
            )}
            <Button
              className="notify-me-btn"
              onClick={async () => {
                const isValid = await triggerValidation(['email', 'newAdministrativeDivision'])

                if (!isValid) return

                let res = await awaitWithLoading(
                  sessionContext.registerPasswordless(getValues()['email'], null, getValues()['newAdministrativeDivision'])
                )
                if (res.ok) {
                  await UserApi.patchUserState(getValues()['newAdministrativeDivision'])
                  sessionContext.logout()
                }
                handleDisagree()
              }}
              color="primary"
            >
              Notify me
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <img className="skywatch-logo-small margin-bottom-basic margin-left-basic" src={BrokerConfigService.getLogo()} />

      <div className="text-promotion bold blue margin-left-basic margin-bottom-18">Welcome to VOOM Pay Per Mile Motorcycle Insurance</div>

      <div className="text-body black margin-left-basic margin-bottom-18">
        <div className="bold margin-bottom-small">Save up to 60% off of your current rates.</div>
        No hardware, no tracking, based on an image of your odometer.
      </div>
      <Grid className="margin-bottom-18" container>
        <Grid item xs={12} md={8}>
          {/* <TextField  
                    fullWidth
                    variant="outlined" type="email" 
                    InputProps={{endAdornment: <InputAdornment position="end"><MailOutlineIcon className='lightgrayblue' /></InputAdornment>}}
                    className="margin-top-small margin-bottom-basic" placeholder="your@email.com" name="email" 
                    inputRef={register({required: true, pattern: { value: EMAIL_REGEX, message: "Invalid email address"}})} 
                    helperText={!!errors.email && (errors.email.message || "Email required")} error={!!errors.email} /> */}

          <div className="text-body bold blue margin-top-small margin-bottom-small margin-left-basic">Select State</div>
          <div className="margin-left-basic">
            {!isLoadingStates ? (
              <Controller
                control={control}
                rules={{ validate: field => field && field != 'default' }}
                name="administrativeDivision"
                defaultValue={'default'}
                as={
                  <Select variant="outlined" fullWidth>
                    <MenuItem disabled value={'default'}>
                      <div className="placeholder-text">Select State</div>
                    </MenuItem>
                    {statesLive.map(administrativeDivision => {
                      return (
                        <MenuItem key={administrativeDivision.code} value={administrativeDivision.code}>
                          {administrativeDivision.name}
                          <div className="text-small gray margin-left-small">Live</div>
                        </MenuItem>
                      )
                    })}
                    <MenuItem value={'other'} onClick={handleClickOpen} className="other-states-text">
                      Other
                    </MenuItem>
                  </Select>
                }
              />
            ) : (
              <CircularProgress />
            )}
            {!!errors.administrativeDivision && <FormHelperText error={!!errors.administrativeDivision}>Required</FormHelperText>}
          </div>
        </Grid>
      </Grid>
      <div className="margin-left-basic">
        <FormControlLabel
          name="terms_agree"
          inputRef={register({ required: true, validate: field => !!field })}
          className="margin-top-small"
          label={
            <div className="text-body gray">
              I agree to the{' '}
              <span onClick={openTermsAndCondition} className="bold clickable underline">
                Terms and Conditions
              </span>{' '}
              and{' '}
              <span onClick={openPrivacyPolicy} className="bold clickable underline">
                Privacy Policy
              </span>
            </div>
          }
          control={<Checkbox color={'primary'} />}
        />
        {!!errors.terms_agree && (
          <FormHelperText error={!!errors.terms_agree}>Must agree to the Terms and Conditions and Privacy Policy</FormHelperText>
        )}
      </div>
      <FlexView className="margin-top-basic margin-left-basic">
        <ContinueButton onClick={onContinue} label={'Continue'}></ContinueButton>
        <div>
          <OutlinedButton onClick={routeToLoginViaRetrieveAQuote}>Retrieve a quote</OutlinedButton>
        </div>
      </FlexView>
      <div className="text-body gray margin-left-basic margin-top-medium margin-bottom-18">
        Existing account?
        <span onClick={routeToLoginViaLogin} className="blue underline textcenter clickable">
          Log in
        </span>
      </div>
    </Container>
  )
}
